/* VÆLD — sparkle button.
   A quiet signature flourish pinned bottom-right. Fades in once the
   visitor has scrolled past the first viewport; clicking it glides the
   page back to the top. Hidden until then so it never clutters the hero. */

(function () {
  'use strict';

  var btn = document.querySelector('[data-sparkle]');
  if (!btn) return;

  var shown = false;
  var ticking = false;

  function evaluate() {
    var past = window.scrollY > window.innerHeight * 0.6;
    if (past !== shown) {
      shown = past;
      btn.classList.toggle('is-visible', shown);
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(evaluate);
    }
  }, { passive: true });

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  evaluate();
})();
